module.exports = __webpack_public_path__ + "img/gray-image.7c6c167a.svg";